module.exports = __webpack_public_path__ + "img/Ellipse6.a5e23a35.png";